import React from 'react';
import Svg from 'rp-react-svg-icon';

const failedRequestComponent = () => (
    <div className="ui-errorMessage">
        <Svg size="XL" iconName="results" />
        <div className="ui-errorMessage__text">
            <div>Search failed.</div>
            <div className="ui-errorMessage__text_error">
                Error loading data, please try again.
            </div>
        </div>
    </div>
);


export default failedRequestComponent;



// WEBPACK FOOTER //
// ./src/client/components/GriddleRP/FailedRequestComponent.js